import { GrammarCardCTA } from '@src/components/Cards/GrammarCard'
import { ConnectedPlagiarismCardCTA as PlagiarismCardCTA } from '@src/components/Cards/PlagiarismCard'
import { getCardAcceptTestId, getCardRejectTestId } from '@src/utils/dataTestIds/getters'
import * as React from 'react'
import styled from 'styled-components'
import { UnstyledButton } from '../base/Buttons'
import { VisuallyHidden } from './styles'
import { GrammarCardState } from './types'

export interface BaseCardCTAProps {
  handleAccept?: () => void
  handleIgnore?: () => void
  acceptText: string
  ignoreText: string
  'aria-labelledby': string
  id: string
}

export interface CardCTAProps extends BaseCardCTAProps {
  type: string
  withReplacements: boolean
  id: string
}

type Props = CardCTAProps & GrammarCardState

const CardCTAContainer = styled.div`
  display: flex;
  margin-top: 20px;
`
export const CTA = styled(UnstyledButton)`
  font-weight: bold;
  color: ${({ theme }) => theme.colors.link};
  font-size: ${({ theme }) => theme.font.text.size.sm};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`

const IgnoreCTA = styled(CTA)`
  margin-left: 20px;
  &:hover {
    text-decoration: underline;
  }
`

export class BaseCTA extends React.PureComponent<BaseCardCTAProps> {
  public render() {
    const { acceptText, ignoreText, 'aria-labelledby': ariaLabelledBy, id } = this.props
    return (
      <CardCTAContainer>
        <CTA
          onClick={this.accept()}
          data-test={getCardAcceptTestId(acceptText)}
          aria-labelledby={`--accept-label-${id} ${ariaLabelledBy}`}
          id={`--accept-label-${id}`}
        >
          {acceptText}
        </CTA>
        <IgnoreCTA
          onClick={this.ignore()}
          data-test={getCardRejectTestId(ignoreText)}
          aria-labelledby={`--ignore-label-${id} ${ariaLabelledBy}`}
          id={`--ignore-label-${id}`}
        >
          {ignoreText}
          <VisuallyHidden>the issue</VisuallyHidden>
        </IgnoreCTA>
      </CardCTAContainer>
    )
  }

  private accept = () => this.props.handleAccept
  private ignore = () => this.props.handleIgnore
}

const CardCTA: React.FunctionComponent<Props> = props => {
  const cardActionComponents = {
    spellcheck: GrammarCardCTA,
    language: GrammarCardCTA,
    plagiarism: PlagiarismCardCTA,
    wtai: GrammarCardCTA,
    rules: GrammarCardCTA,
    classifiers: GrammarCardCTA,
  }
  if (!props.type) {
    return null // defend against a bug with overlapping cards
  }

  const ComponentActions: React.FunctionComponent = cardActionComponents[props.type]
  return <ComponentActions {...props} />
}

export default CardCTA



// WEBPACK FOOTER //
// ./src/components/Cards/CardActions.tsx